import { type calculateQuote, formatBrl } from '@estac1/shared';
import { Card, CardContent, Input, Label } from '@estac1/ui';

interface PricingPreviewCardProps {
  previewVacancies: number;
  onPreviewVacancies: (v: number) => void;
  previewSamples: Array<{
    vacancies: number;
    quote: ReturnType<typeof calculateQuote>;
  }>;
  validationError: string | null;
}

export const PricingPreviewCard = ({
  previewVacancies,
  onPreviewVacancies,
  previewSamples,
  validationError,
}: PricingPreviewCardProps) => (
  <Card>
    <CardContent className="space-y-4 pt-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-baseline sm:justify-between">
        <div>
          <h3 className="text-sm font-semibold">Pré-visualização</h3>
          <p className="text-xs text-muted-fg">
            Mostra quanto cada faixa pagaria com a tabela acima.
            {validationError ? ' Corrija os erros para ver o cálculo correto.' : ''}
          </p>
        </div>
        <div className="w-32">
          <Label htmlFor="preview-vacancies" className="text-xs">
            Testar com
          </Label>
          <Input
            id="preview-vacancies"
            type="number"
            min={1}
            value={previewVacancies}
            onChange={(e) =>
              onPreviewVacancies(Math.max(1, Number.parseInt(e.target.value, 10) || 1))
            }
            className="mt-1"
          />
        </div>
      </div>
      <ul className="divide-y divide-border rounded border border-border">
        {previewSamples.map((sample) => (
          <li
            key={sample.vacancies}
            className="flex items-baseline justify-between px-4 py-2 text-sm"
          >
            <span className="font-mono text-muted-fg">{sample.vacancies} vagas</span>
            {sample.quote.ok ? (
              <span className="font-semibold text-fg">
                {formatBrl(sample.quote.totalCents)}
                <span className="ml-1 text-xs font-normal text-muted-fg">/mês</span>
              </span>
            ) : (
              <span className="text-xs text-muted-fg">{sample.quote.message}</span>
            )}
          </li>
        ))}
      </ul>
    </CardContent>
  </Card>
);
